import { render } from "./Update.vue?vue&type=template&id=79b340c8&scoped=true"
import script from "./Update.vue?vue&type=script&lang=ts"
export * from "./Update.vue?vue&type=script&lang=ts"

import "./Update.vue?vue&type=style&index=0&id=79b340c8&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-79b340c8"

export default script